import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

const isNative = Capacitor.isNativePlatform();

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    // 네이티브 앱에서는 URL에서 세션 자동 감지를 비활성화
    // (deep link 핸들러에서 수동으로 처리)
    detectSessionInUrl: !isNative,
    // 네이티브 앱에서는 자동 URL 리다이렉트 비활성화
    ...(isNative && { autoRefreshToken: true, persistSession: true }),
  },
});
